module.exports = __webpack_public_path__ + "img/hcdl_gallery1.663b6644.jpg";